import { useEffect } from 'react';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePsfSharePageData } from 'src/app/pages/psf/share/pageContext';
import { pullBandit } from 'src/app/shared/api/bandits';

export function usePullBandits() {
	const {
		data: { bandits },
	} = usePsfSharePageData();
	const utilityContext = useUtilityContext();

	useEffect(() => {
		if (bandits.psfShareCopy.variant) {
			void pullBandit(
				{ experimentName: bandits.psfShareCopy.experimentName, variantName: bandits.psfShareCopy.variant.variantName },
				utilityContext,
				{ silent: true },
			);
		}
		// we only want to do it once per view
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
}
